import { VIDEO_MODAL_TOGGLE, CREDIT_MODAL_TOGGLE, QUALIFICATION_MODAL_TOGGLE } from '../Type';

const INITIAL = {
  isVideoModalOpen: false,
  isCreditModalOpen: false,
  isQualificationModalOpen: false,
}

export default (state = INITIAL, action) => {
  switch (action.type) {
    case VIDEO_MODAL_TOGGLE: {
      const { isOpen, info } = action.data;
      return { ...state, isVideoModalOpen: isOpen, info };
    }

    case CREDIT_MODAL_TOGGLE: {
      const { isOpen, info } = action.data;
      return { ...state, isCreditModalOpen: isOpen, creditModalInfo: info };
    }

    case QUALIFICATION_MODAL_TOGGLE: {
      const { isOpen, info } = action.data;
      return { ...state, isQualificationModalOpen: isOpen, qualification_info: info };
    }

    default:
      return state;
  }
}